import { useState, useEffect, useCallback } from "react";
import { checkEmailStatus } from "../services/authService";
import { isValidEmail } from "../utils/formatting";

const useEmailValidation = (email, roleType) => {
  const [status, setStatus] = useState("idle"); // 'idle', 'available', 'exists_no_role', 'exists_with_role', 'error'
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailData, setEmailData] = useState(null);

  const validateEmail = useCallback(async () => {
    if (!email || !isValidEmail(email)) {
      setStatus("idle");
      setEmailData(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await checkEmailStatus(email);
      const data = response.data;

      setEmailData(data);

      if (!data.exists) {
        setStatus("available");
      } else {
        // Check role based on roleType
        if (roleType === "company") {
          if (data.hasCompanyRole) {
            setStatus("exists_with_role");
          } else {
            setStatus("exists_no_role");
          }
        } else if (roleType === "restaurant") {
          if (data.hasRestaurantRole) {
            setStatus("exists_with_role");
          } else {
            setStatus("exists_no_role");
          }
        } else {
          // If no roleType specified, check for any admin role
          if (data.hasAdminRole) {
            setStatus("exists_with_role");
          } else {
            setStatus("exists_no_role");
          }
        }
      }
    } catch (err) {
      setStatus("error");
      setError(err.message || "Failed to check email status");
      setEmailData(null);
    } finally {
      setIsLoading(false);
    }
  }, [email, roleType]);

  useEffect(() => {
    // Debounce email validation
    const timeoutId = setTimeout(() => {
      validateEmail();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [validateEmail]);

  const canProceed =
    status === "available" || status === "exists_no_role";

  return {
    status,
    isLoading,
    error,
    canProceed,
    emailData,
    refetch: validateEmail,
  };
};

export default useEmailValidation;



